import { render, staticRenderFns } from "./examinationAuthenticate.vue?vue&type=template&id=f5bcccf4"
import script from "./examinationAuthenticate.vue?vue&type=script&lang=js"
export * from "./examinationAuthenticate.vue?vue&type=script&lang=js"
import style0 from "./examinationAuthenticate.vue?vue&type=style&index=0&id=f5bcccf4&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports